import type { OnboardingStep, OrganizationTab } from "../account";

export const organizationTabs: Array<{
  id: OrganizationTab;
  label: string;
}> = [
  { id: "overview", label: "Yhteenveto" },
  { id: "areas", label: "Alueet" },
  { id: "permits", label: "Luvat" },
  { id: "team", label: "Tiimi" },
  { id: "finance", label: "Talous" },
  { id: "package", label: "Paketti ja laskutus" },
  { id: "settings", label: "Asetukset" },
];

export const workspaceNavigationLabels: Array<{
  id: OrganizationTab;
  label: string;
}> = [
  { id: "overview", label: "Yhteenveto" },
  { id: "areas", label: "Alueet" },
  { id: "permits", label: "Luvat" },
  { id: "team", label: "Tiimi" },
  { id: "finance", label: "Talous" },
  { id: "package", label: "Paketti" },
  { id: "settings", label: "Asetukset" },
];

export const goalDefinitions = [
  {
    id: "area_management",
    title: "Hallinnoi vesialueita",
    text: "Liitä organisaatio julkaistuihin Core-alueisiin.",
    capabilities: ["manage_areas"],
  },
  {
    id: "permit_issuing",
    title: "Myönnä kalastuslupia",
    text: "Kytke organisaatio lupatuotteiden luvanmyöntäjäksi.",
    capabilities: ["issue_permits"],
  },
  {
    id: "permit_sales",
    title: "Myy lupia ja vastaanota maksuja",
    text: "Valmistele lupakauppa, maksutili ja tilausten käsittely.",
    capabilities: [
      "sell_permits",
      "receive_payments",
      "manage_orders",
      "handle_refunds",
      "view_financial_reports",
    ],
  },
] as const;

export function stepStatusLabel(status: OnboardingStep["status"]) {
  return {
    complete: "Valmis",
    current: "Tee seuraavaksi",
    waiting: "Odottaa tarkastusta",
    locked: "Lukittu",
  }[status];
}

export function resolveOrganizationTab(value: string | null): OrganizationTab {
  return organizationTabs.some((tab) => tab.id === value)
    ? (value as OrganizationTab)
    : "overview";
}
